"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScriptsPathBuilder = /** @class */ (function () {
    function ScriptsPathBuilder() {
    }
    ScriptsPathBuilder.prototype.build = function (modConfig) {
        return modConfig.map(function (module) {
            if (module.fileParameters === undefined ||
                module.fileParameters === null ||
                module.fileParameters.trim() === '') {
                return module.servicePath;
            }
            else {
                return module.servicePath + module.fileExtension + '?' + module.fileParameters;
            }
        });
    };
    return ScriptsPathBuilder;
}());
exports.ScriptsPathBuilder = ScriptsPathBuilder;
//# sourceMappingURL=ScriptsPathBuilder.js.map